import { fetchApiDataV2 } from '../../utils/utils';

export const fetchKidsLandingData = async (appInfo) => {
  const topTrendingResp = await fetchApiDataV2(appInfo, 'category/top_trending');
  return topTrendingResp;
};
